<template lang="pug">
  .giftcard-opts
    RogueInput(
      label="Custom Value"
      required="Please enter a value."
      v-if="value.customAmount !== null"
      type="text"
      :validateFn="validateAmount"
      :placeholder="__('Minimum Amount:')+' '+$rogue.currency('25')"
      :modelValue="customAmount"
      @update:modelValue="setCustomAmount"
    )
    .send-to
      p.font-weight-bold {{__('To')}}:
      RogueInput(
        label="Recipient's Name"
        required="Please enter a recipient."
        type="text"
        v-model="value.recipientName"
      )
      RogueInput(
        v-if="value.delivery === 'email'"
        label="Recipient's Email Address"
        type="email"
        required="Please enter a valid email."
        v-model="value.recipientEmail"
      )
      RogueInput(
        label="Confirm Recipient's Email Address"
        v-if="value.delivery === 'email'"
        type="email"
        required="Please enter the recipient's email address again."
        :validateFn="validateEmailMatch"
        v-model="value.recipientEmailConfirm"
      )
      p.font-weight-bold {{__('From')}}:
      RogueInput(
        label="Sender's Name"
        required="Please enter your name"
        type="text"
        v-model="value.senderName"
      )
      RogueInput(
        label="Senders Email Address"
        type="email"
        required="Please enter your email address"
        v-model="value.senderEmail"
      )
      RogueTextarea(
        :label="`Personal Message (${value.message.length} / 255)`"
        v-model="value.message"
        :maxlength="255"
      )
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRogue } from '@/js/services/Rogue'
import type { GiftcardMetadata } from '@/js/services/types/order'

const props = withDefaults(defineProps<{
  value?: GiftcardMetadata
}>(), {
  value: () => ({} as GiftcardMetadata),
})

const rogue = useRogue()

const customAmount = ref(0)

onMounted(() => {
  if (props.value.customAmount) {
    customAmount.value = props.value.customAmount
  }
})

function validateAmount(num: string | number) {
  const val = parseFloat(`${num}`)
  if (Number.isNaN(val) || val < 25) {
    return `Please enter a value greater than ${rogue.currency(25)}`
  }

  return null
}

function setCustomAmount(val: string | number | null) {
  if (!val) {
    customAmount.value = 0

    return
  }

  const parsed = `${val}`.replace(/[^\d.]/g, '')
  // Keeps the input field within the allowed values range
  const retval = Math.min(Math.round(parseFloat(parsed) * 100) / 100, 1000000)

  if (Number.isNaN(retval)) {
    customAmount.value = 0

    return
  }

  customAmount.value = retval

  if (validateAmount(retval) === null) {
    props.value.customAmount = retval
  }
}

function validateEmailMatch(val: string) {
  if (val.toLowerCase().trim() !== (props.value.recipientEmail || '').toLowerCase().trim()) {
    return 'Recipient email fields do not match.'
  }

  return null
}
</script>
